import { useEffect } from "react";
// @ts-ignore
import { useCopilotKit } from "@copilotkit/react-core/v2";
import growl from "app/components/common/growl";

const AUTH_ERROR_PATTERN = /invalidtokenexception|invalid.*(auth|token)|unauthorized|not\s*authenticated|session.*expired/i;

const SESSION_EXPIRED_MESSAGE = "Your session has expired. Please refresh the page and log in again.";

const GROWL_SUPPRESS_WINDOW_MS = 15000;

let lastGrowlAt = 0;

export const useToolErrorReporting = () => {
    const { copilotkit } = useCopilotKit();

    useEffect(() => {
        const subscription = copilotkit.subscribe({
            onToolExecutionEnd: ({ error }: { error?: string }) => {
                if (!error || !AUTH_ERROR_PATTERN.test(error)) return;

                const now = Date.now();
                if (now - lastGrowlAt < GROWL_SUPPRESS_WINDOW_MS) return;
                lastGrowlAt = now;

                growl.error(SESSION_EXPIRED_MESSAGE, "Session expired");
            },
            onError: event => {
                console.error("Error Event", event);
            }
        });

        return () => subscription.unsubscribe();
    }, [copilotkit]);
};
